<template>
  <div>
    <b-card>
      <b-tabs>
        <b-tab title="Dados">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-alert
                  show
                  variant="primary"
                >
                  <div class="alert-body">
                    <feather-icon
                      class="mr-25"
                      icon="InfoIcon"
                    />
                    <span class="ml-25">Esse cadastro é uma regra na vetorização, faz a consulta do que não deve ser vetorizado, então deve ser cadastrado previamente todos os tipos de conteudos que o publisher não deve vetorizar.</span>
                  </div>
                </b-alert>
            </b-row>
            <b-row>

              <!-- Origem -->
              <b-col md="6">
                <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                  >
                    <span slot="no-options">{{ $t('GENERAL.NoOptions') }}</span>
                  </v-select>
                </b-form-group>
              </b-col>

              <!-- Período -->
              <b-col md="6">
                <b-form-group>
                  <label>{{ "Período" }}</label>
                  <flat-pickr v-model="form.dt_period" placeholder="Período válido da regra" :config="{
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                    allowInput: true,
                  }" />
                </b-form-group>
              </b-col>

              <!-- Fonte Externa -->
              <b-col md="6">
                <b-form-group>
                  <label>{{ "Fonte Externa" }}</label>
                  <b-form-input
                    id="external_source_origin"
                    placeholder="Fonte externa"
                    v-model="form.external_source_origin"
                  />
                </b-form-group>
              </b-col>

              <!-- Layout -->
              <b-col md="6">
                <b-form-group label="Layout" label-for="layout-select">
                  <v-select
                    id="layout-select"
                    v-model="form.layout"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :reduce="opt => opt.value"
                    :options="layoutOptions"
                  >
                    <span slot="no-options">{{ $t('GENERAL.NoOptions') }}</span>
                  </v-select>
                </b-form-group>
              </b-col>

              <!-- Tags -->
              <b-col md="12">
                <b-form-group label="Tags" label-for="tags-input">
                  <b-form-tags
                    id="tags-input"
                    v-model="form.tags"
                    input-id="tags-basic"
                    placeholder="Adicionar tag e pressionar Enter"
                  />
                </b-form-group>
              </b-col>

              <!-- Subjects -->
              <b-col md="12">
                <b-form-group label="Assuntos" label-for="subjects-list">
                  <v-select
                    id="subjects-list"
                    v-model="form.subjects"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :reduce="sub => sub._id"
                    :options="subjects"
                    multiple
                    :close-on-select="false"
                  >
                    <span slot="no-options">{{ $t('GENERAL.NoOptions') }}</span>
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>

              <!-- Campos de auditoria (somente leitura) -->
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="dt-created" placeholder="Data Criação" v-model="form.dt_create" disabled />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email-created" placeholder="Email Criação" v-model="form.email_create" disabled />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="dt-update" placeholder="Data Alteração" v-model="form.dt_update" disabled />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email-update" placeholder="Email Alteração" v-model="form.email_update" disabled />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="dt-delete" placeholder="Data Desativação" v-model="form.dt_delete" disabled />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="email-delete" placeholder="Email Desativação" v-model="form.email_delete" disabled />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col class="mb-2" md="12"><hr /></b-col>

              <!-- Ativo -->
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- Botões -->
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTags,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  BAlert,
} from "bootstrap-vue";
import vSelect from "vue-select";
import vectorizationManagementService from "@/providers/vectorizationManagementService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import AppConstants from "@/appConstants";
import flatPickr from "vue-flatpickr-component";

const LAYOUT_OPTIONS = [
  { value: 1, text: "Notícia" },
  { value: 2, text: "Pisca" },
  { value: 3, text: "Podcast" },
  { value: 4, text: "Video" },
  { value: 5, text: "Relatórios" },
  { value: 6, text: "Eventos" },
];

export default {
  props: {},
  components: {
    BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BFormTags,
    BForm, BButton, BTabs, BTab, BCard, vSelect, BAlert, flatPickr
  },
  data() {
    return {
      dataID: null,
      origins: [],
      subjects: [],
      layoutOptions: LAYOUT_OPTIONS,
      form: {
        _id: "",
        active: true,
        origin: null,
        dt_period: null,
        tags: [],
        layout: null,
        external_source_origin: "",
        subjects: [],
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", "Novo");
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
    }
    this.loadData();
  },
  computed: {
    isUpdate() {
      return !!this.$route.params.id;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_VECTORIZATION_MANAGEMENT);
    },
    onSubmit() {
      vectorizationManagementService
        .register(this.form, new URLSearchParams())
        .then(() => {
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getDetails() {
      vectorizationManagementService
        .getDetails(this.dataID, new URLSearchParams())
        .then((res) => {
          this.form._id = res._id;
          this.form.active = res.active;
          this.form.origin = res.origin ? { id: res.origin._id, name: res.origin.name } : null;
          this.form.dt_period = res.dt_period ? res.dt_period.substring(0, 10) : null;
          this.form.tags = res.tags || [];
          this.form.layout = res.layout;
          this.form.external_source_origin = res.external_source_origin || "";
          this.form.subjects = res.subjects ? res.subjects.map((s) => s._id) : [];
          this.form.dt_create = res.dt_create ? convertDatetimeHelper.convertStringToDateTime(res.dt_create) : "";
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : "";
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : "";
          this.form.email_create = res.email_create || "";
          this.form.email_update = res.email_update || "";
          this.form.email_delete = res.email_delete || "";
          this.$store.dispatch("admin/updatePageTitle", res.external_source_origin || res._id);
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      const originsPromise = dropdownService.getAllOrigin(new URLSearchParams());
      const subjectsPromise = dropdownService.getAllSubjects(new URLSearchParams());

      Promise.all([originsPromise, subjectsPromise])
        .then(([originsRes, subjectsRes]) => {
          this.origins = originsRes;
          this.subjects = subjectsRes.map(item => {item._id = item.id; return item;});
          if (this.isUpdate) {
            this.getDetails();
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style></style>
